export default function IconSquareChevDown({
  color = '#1E293B',
  width = 28,
  height = 28,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.5'
        y='-0.5'
        width='27'
        height='27'
        rx='3.5'
        transform='matrix(1 0 0 -1 0 27)'
        fill='#F5F5F5'
      />
      <rect
        x='0.5'
        y='-0.5'
        width='27'
        height='27'
        rx='3.5'
        transform='matrix(1 0 0 -1 0 27)'
        stroke='#CFCDDA'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.71209 10.5246C8.0782 10.1585 8.6718 10.1585 9.03791 10.5246L14 15.4867L18.9621 10.5246C19.3282 10.1585 19.9218 10.1585 20.2879 10.5246C20.654 10.8907 20.654 11.4843 20.2879 11.8504L14.6629 17.4754C14.2968 17.8415 13.7032 17.8415 13.3371 17.4754L7.71209 11.8504C7.34597 11.4843 7.34597 10.8907 7.71209 10.5246Z'
        fill={color}
      />
    </svg>
  );
}
